import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import randomstring from 'uuid/v4';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/forecast.actions';
import * as machine_actions from '../../../../actions/machine.actions';
import * as home from '../../../../actions/process.home.actions';

import Hidden from '@material-ui/core/Hidden';
import Button from '@material-ui/core/Button';
import Undo from '@material-ui/icons/Undo';

import Menu from '../Menu';
import Total from './Total';
import Info from './Info';
import Selector from './Selector';
import Machine from './Machine';
import Forecast from './Forecast';
import ProductMix from './ProductMix';
import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import Snackbar from '../../../labels/Snackbar';
// eslint-disable-next-line
import style from './_style.css';

function toolbar(handle) {
    return <Undo key="undo-changes" className="hand" color="primary" onClick={handle} />;
}

class ForecastMain extends React.Component {
    state = {
        id: randomstring(),
        aceptado: false,
        index: -1,
    };

    constructor(props) {
        super(props);
        props.load(props.id);
    }

    componentDidMount() {
        const tools = [toolbar(this.handleLoad)];
        this.props.setTools(tools);
    }

    componentWillUnmount() {
        this.props.setTools([]);
    }

    static getDerivedStateFromProps(props, state) {
        if (props.forecast && (props.forecast !== state.forecast || props.id !== state.id)) {
            const {
                aceptado,
                aceptadoPor,
                alertaprod,
                creado,
                fecha,
                idLocal,
                importemix,
                importesbase,
                importes,
                desvioactual,
                maquinas,
                nLocal,
                productos,
                productosbase,
                periodocomanda,
                propuesta,
                ventadia,
                ventadiabase,
                caducado,
            } = props.forecast;

            state.forecast = props.forecast;
            state.id = props.id;
            state.aceptado = aceptado ? aceptado : false;
            state.aceptadoPor = aceptadoPor ? aceptadoPor : '';
            state.alertaprod = alertaprod ? alertaprod : '';
            state.creado = creado ? creado : '';
            state.fecha = fecha ? fecha : '';
            state.idLocal = idLocal ? idLocal : '';
            state.importemix = importemix ? importemix : undefined;
            state.importes = importes ? importes : [];
            state.importesbase = importesbase
                ? importesbase
                : importes
                    ? JSON.parse(JSON.stringify(importes))
                    : [];
            state.maquinas = maquinas ? maquinas : [];
            state.nLocal = nLocal ? nLocal : '';
            state.periodocomanda = periodocomanda ? periodocomanda : undefined;
            state.productos = productos ? productos : {};
            state.productosbase = productosbase
                ? productosbase
                : productos
                    ? JSON.parse(JSON.stringify(productos))
                    : {};
            state.propuesta = propuesta ? propuesta : false;
            state.ventadia = ventadia ? ventadia : undefined;
            state.ventadiabase = ventadiabase ? ventadiabase : ventadia;
            state.caducado = caducado ? caducado : undefined;
            state.desvioactual = desvioactual ? desvioactual : '';

            return state;
        }
        return null;
    }

    handleLoad = (event) => {
        this.setState({ index: -1 });
        this.props.load(this.props.id);
    };

    handleChange = (name, value) => {
        this.setState({ [name]: value });
    };

    handleChangeStatusMachine(id, status) {
        this.props.status(id, status);
    }

    handleChangeProducts = (index, value) => {
        const { productos } = this.state;
        productos[index].mix = value;
        this.setState({ productos: productos });
    };

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    handleCloseError = () => {
        this.setState({ error: '' });
    };

    handleSubmit = (event) => {
        const { id, importes, productos } = this.state;

        const forecast = {
            id,
            importes,
            productos,
        };
        this.props
            .edit(forecast)
            .then((result) => {
                if (this.props.back) {
                    this.props.history.push(`/ouichef/${this.props.back}`);
                } else {
                    this.props.history.push('/xef/forecast');
                }

            })
            .catch((error) => this.setState({ error: error.message }));
    };

    render() {
        const { intl, info, forecasts_is_loading, forecasts_has_errored } = this.props;
        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '66' || f === '59' || f === '20')  &&
              info.security.licencias.some((f) => f.id === 154 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else if (forecasts_has_errored.hasErrored) {
            return (
                <Error open type={forecasts_has_errored.hasErrored}  message={forecasts_has_errored.error} handleClose={this.handleBack} />
            );
        } else {
            const {
                nLocal,
                creado,
                ventadia,
                ventadiabase,
                aceptado,
                index,
                importemix,
                importes,
                importesbase,
                productos,
                productosbase,
                desvioactual,
                maquinas,
                error,
                caducado,
            } = this.state;

            const enabledRanges = importes.reduce((total, i) => {
                total = total + (i.bloqueado ? 0 : 1);
                return total;
            }, 0);
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    <Hidden xsDown>
                        <div
                            className={
                                'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white'
                            }
                            onScroll={this.handleScroll}
                        >
                            <Menu code={2} />
                        </div>
                    </Hidden>
                    {forecasts_is_loading && <Loading open opacity />}
                    <div className={'flex_full_row center'}>
                        <div
                            className={
                                'flex_full overflow_y_scroll height100 padding_borders bg_ice_blue showbar'
                            }
                        >
                            <Info
                                {...this.props}
                                info={{ nLocal: nLocal, fecha: creado, importemix: importemix }}
                            />
                            <Total
                                {...this.props}
                                onChange={this.handleChange}
                                info={{
                                    ventadia: ventadia,
                                    ventadiabase: ventadiabase,
                                    importes: importes,
                                    desvioactual: desvioactual,
                                    disabled:
                                        index !== -1 ||
                                        !!aceptado ||
                                        enabledRanges === 0 ||
                                        !!caducado,
                                }}
                            />
                            <Selector {...this.props} index={index} onChange={this.handleChange} />
                            {index === -1 && (
                                <Forecast
                                    {...this.props}
                                    leyend={'€'}
                                    disabled={!!aceptado || enabledRanges === 0 || !!caducado}
                                    info={{
                                        initial: importesbase,
                                        current: importes,
                                    }}
                                    ventadia={ventadia}
                                    onChange={this.handleChange}
                                />
                            )}
                            {index !== -1 && (
                                <ProductMix
                                    {...this.props}
                                    leyend={
                                        intl.formatMessage({ id: 'units' }) +
                                        ' / ' +
                                        importemix +
                                        ' €'
                                    }
                                    disabled={!!aceptado || enabledRanges === 0 || !!caducado}
                                    info={{
                                        initial: productosbase[index].mix,
                                        current: productos[index].mix,
                                        desvioactualuds: productos[index].desvioactualuds,
                                        importes: importes,
                                        importesbase: importesbase,
                                        importemix: importemix,
                                    }}
                                    index={index}
                                    ventadia={ventadia}
                                    onChange={this.handleChangeProducts}
                                />
                            )}
                            <Machine
                                {...this.props}
                                info={maquinas}
                                onChange={this.handleChangeStatusMachine.bind(this)}
                            />
                            <Button
                                disabled={!!aceptado || enabledRanges === 0 || !!caducado}
                                variant="contained"
                                color="primary"
                                className={'production_buttom'}
                                onClick={this.handleSubmit}
                            >
                                <FormattedMessage id="production_table_buttom" />
                            </Button>
                        </div>
                    </div>
                    {error && (
                        <Snackbar
                            open={true}
                            variant="error"
                            text={error}
                            onClose={this.handleCloseError.bind(this)}
                        />
                    )}
                </div>
            );
        }
    }
}

ForecastMain.propTypes = {
    intl: intlShape.isRequired,
};

const mapStateToProps = (state) => {
    return {
        window_searchs: state.window_searchs,
        forecast: state.forecast,
        forecasts_has_errored: state.forecasts_has_errored,
        forecasts_is_loading: state.forecasts_is_loading,
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, machine_actions, home), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(injectIntl(ForecastMain)));



// WEBPACK FOOTER //
// ./src/components/complex/inventory/forecast/Index.js